
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AclService } from './acl.service';
import { RoleService } from './role.service';
import { SettingsService } from './settings.service';
import { UserService } from './user.service';
import { VersionCheckService } from './version-check.service';
import { WindowService } from './window.service';

const SERVICES = [
	AclService,
	RoleService,
	UserService,
	WindowService,
	VersionCheckService,
	SettingsService,
];

@NgModule({
	imports: [
		CommonModule,
	],
	providers: [
		...SERVICES,
	],
})
export class DataModule {
	public static forRoot(): ModuleWithProviders<DataModule> {
		return {
			ngModule: DataModule,
			providers: [
				...SERVICES,
			],
		};
	}
}
